'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data) {
  var x = d3.scale.ordinal().domain(_.map(data, 'value')).rangeBands([0, params.width], 0.1, 0.05);
  var y = d3.scale.linear().domain([0, 1]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;